import React from 'react';

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <div className="section-title">
          <h2>ارتباط با ما</h2>
          <p>همیشه در جریان آخرین رویدادها و فعالیت‌های دانشگاهی باشید</p>
        </div>
        
        {/* Scientific Associations Telegram Channel - Featured */}
        <div className="telegram-anjoman-featured">
          <a 
            href="https://t.me/anjoman_shomalamol" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="telegram-anjoman-link"
          >
            <div className="telegram-icon-wrapper">
              <i className="fab fa-telegram-plane"></i>
            </div>
            <div className="telegram-content">
              <h3>کانال تلگرام انجمن‌های علمی</h3>
              <p>🎓 برای اطلاع از فعالیت‌های انجمن علمی رشته‌تان، همایش‌ها، کارگاه‌ها، اردوهای علمی و رویدادهای دانشجویی به کانال رسمی انجمن‌های علمی دانشگاه شمال بپیوندید!</p>
              <span className="join-text">عضویت در کانال <i className="fas fa-arrow-left"></i></span>
            </div>
          </a>
        </div>

        {/* Other University Links */}
        <div className="section-subtitle">
          <h3>سایر کانال‌های ارتباطی دانشگاه</h3>
        </div>
        <div className="contact-links">
          <a href="https://edu.shomal.ac.ir/" target="_blank" rel="noopener noreferrer" className="contact-link">
            <i className="fas fa-globe"></i>
            سایت دانشگاه شمال
          </a>
          <a href="https://t.me/shomal_university_official" target="_blank" rel="noopener noreferrer" className="contact-link">
            <i className="fas fa-paper-plane"></i>
            کانال تلگرام دانشگاه شمال
          </a>
          <a href="https://instagram.com/shomaluniversityofficial" target="_blank" rel="noopener noreferrer" className="contact-link">
            <i className="fab fa-instagram"></i>
            پیج اینستاگرام دانشگاه شمال
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;